import type { FC } from 'react'
import { Button } from '@/common/ui/Form/Button/Button'

const DEFAULT_FILTERED_MESSAGE = 'Записей с выбранным фильтром нет.'

export type ListTableEmptyOverlayProps = {
    show: boolean
    hasActiveFilters: boolean
    onClearFilters?: () => void
    emptyLabel: string
    filteredMessage?: string
}

export const ListTableEmptyOverlay: FC<ListTableEmptyOverlayProps> = ({
    show,
    hasActiveFilters,
    onClearFilters,
    emptyLabel,
    filteredMessage = DEFAULT_FILTERED_MESSAGE,
}) => {
    if (!show) {
        return null
    }

    return (
        <div
            className='pointer-events-none absolute inset-0 flex items-center justify-center px-4 pt-14 text-center'
            role='status'
            aria-live='polite'
        >
            <div className='pointer-events-auto flex max-w-md flex-col items-center gap-3'>
                {hasActiveFilters ? (
                    <>
                        <p className='text-base text-[var(--gray-2,#aba7af)]'>{filteredMessage}</p>
                        {onClearFilters ? (
                            <Button
                                type='button'
                                variant='ghost'
                                emphasis='accent'
                                size='md'
                                onClick={onClearFilters}
                                aria-label='Очистить фильтр'
                            >
                                Очистить фильтр
                            </Button>
                        ) : null}
                    </>
                ) : (
                    <p className='text-base text-[var(--gray-2,#aba7af)]'>{emptyLabel}</p>
                )}
            </div>
        </div>
    )
}
